import { useEffect } from "react";
import { fileCard } from "../attachment/file-resource.tsx";
import type { ListedFile } from "../filed.ts";
import type { Stacking } from "../panel/panels.tsx";
import type { Row } from "../person/arrivals.ts";

export function useSearchTarget(
  conversation: string,
  message: string | null,
  file: string | null,
  rows: readonly Row[],
  files: readonly ListedFile[],
  stack: Stacking,
): void {
  useEffect(() => {
    if (!file) return;
    const found = files.find((one) => one.id === file);
    if (found) stack.open(fileCard(found, conversation));
  }, [conversation, file, files, stack]);

  const messageIsDrawn = message !== null && rows.some((row) => row.id === message);
  useEffect(() => {
    if (!message || !messageIsDrawn || typeof document === "undefined") return;
    const frame = requestAnimationFrame(() => {
      const row = [...document.querySelectorAll('[data-testid^="message-"]')].find(
        (node) => node.getAttribute("data-testid") === `message-${message}`,
      );
      row?.scrollIntoView({ block: "center", behavior: "smooth" });
    });
    return () => cancelAnimationFrame(frame);
  }, [message, messageIsDrawn]);
}
